const DATA_TEST_IDS = {
  limsLimsPermissionsPage: 'module__lims_lims-permissions-page',
} as const;

export default DATA_TEST_IDS;
